const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
const isValidEmail = (email) => {
  if (!email || typeof email !== "string") {
    return false;
  }
  const trimmedEmail = email.trim();
  if (trimmedEmail.length === 0 || trimmedEmail.length > 254) {
    return false;
  }
  const atIndex = trimmedEmail.indexOf("@");
  if (atIndex === -1 || atIndex === 0 || atIndex === trimmedEmail.length - 1) {
    return false;
  }
  if (trimmedEmail.indexOf("@", atIndex + 1) !== -1) {
    return false;
  }
  return EMAIL_REGEX.test(trimmedEmail);
};
const validateEmail = (email, fieldName = "Email") => {
  if (!email.trim()) {
    return `${fieldName} is required`;
  }
  if (!isValidEmail(email)) {
    return "Enter email in the correct format, like name@email.com";
  }
  return "";
};
const validateName = (name, fieldName) => {
  if (!name.trim()) {
    return `${fieldName} is required`;
  }
  return "";
};
const validatechatbotContactReason = (reason) => {
  if (!reason.trim()) return "Contact reason is required";
  if (reason.length > 255) return "Contact reason should not exceed 255 characters";
  return "";
};
const validateOrderNumber = (orderNumber) => {
  if (!orderNumber.trim()) {
    return "Order number is required";
  }
  if (!orderNumber.trim().toUpperCase().startsWith("VP")) {
    return "Enter order number in the correct format, like VP_123456";
  }
  return "";
};

export { EMAIL_REGEX, isValidEmail, validateEmail, validateName, validateOrderNumber, validatechatbotContactReason };
//# sourceMappingURL=src-utils-validation-utils.js.map
